<div class="app-slide-toggle">
  <mat-slide-toggle (change)="sliderChange($event)" [disabled]="disabled" [(ngModel)]="checked">
    @if (label) {
      {{ label }}
    }
  </mat-slide-toggle>
</div>
